module.exports = __webpack_public_path__ + "pokupaem_kvartiru.a9e1beace91502c2a258febbc521551b.jpg";